import React from "react";
import { DxTabbedContent, DxTabPanel } from "genesys-react-components";
import { WrapupCodes } from "./WrapupCodes";
import { QueuesMain } from "./QueuesMain";
import "../App.css";
import { CreateWrapupCode } from "./CreateWrapupCode";

export function Tabs({
  divisions,
  checkedDivisions,
  pageCount,
  setPageCount,
  pageNumber,
  setPageNumber,
  onPageChange,
  activeTab,
  handleClick,
  searchQueues,
  searchWrapupCodes,
}) {
  const divisionsItemGroup = divisions.map((division) => ({
    label: division.name,
    value: division.id,
  }))

  divisionsItemGroup.push({ label: "[All]", value: "*" });
  divisionsItemGroup.sort((a, b) => a.label.localeCompare(b.label))

  return (
    <>
      <DxTabbedContent>
      <DxTabPanel
          title={<button
            className={`tab-button ${activeTab === "Create Wrapup Codes" ? "active" : ""}`}
            onClick={handleClick}
          >Create Wrapup Codes</button>}
          className="create-wrapupcode-panel"
        >
          <CreateWrapupCode 
          // divisions={divisions}
          divisionsItemGroup={divisionsItemGroup}
          />
        </DxTabPanel>
        <DxTabPanel
          title={
            <button
              className={`tab-button ${activeTab === "Queues" ? "active" : ""}`}
              onClick={handleClick}
            >
              Queues
            </button>
          }
          className="wrapup-codes-panel"
        >
          <QueuesMain
            activeTab={activeTab === "Queues" ? "Queues" : false}
            checkedDivisions={checkedDivisions}
            setPageCount={setPageCount}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            onPageChange={onPageChange}
            searchQueuesValue={searchQueues}
            searchWrapupCodesValue={searchWrapupCodes}
          />
        </DxTabPanel>
        <DxTabPanel
          title={<button className="tab-button">Wrapup Codes</button>}
          className="wrapup-codes-panel"
        >
          <WrapupCodes
            divisions={divisions}
            checkedDivisions={checkedDivisions}
            setPageCount={setPageCount}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            divisionsItemGroup={divisionsItemGroup}
            searchWrapupCodesValue={searchWrapupCodes}
          />
        </DxTabPanel>
        <DxTabPanel
          className="wrapup-codes-table-panel"
          title={
            <button
              className={`tab-button ${
                activeTab === "Wrapup Codes Table" ? "active" : ""
              }`}
              onClick={handleClick}
            >
              Wrapup Codes Table
            </button>
          }
        >
          <QueuesMain
            activeTab={
              activeTab === "Wrapup Codes Table" ? "Wrapup Codes Table" : false
            }
            checkedDivisions={checkedDivisions}
            pageCount={pageCount}
            setPageCount={setPageCount}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            searchQueuesValue={searchQueues}
            searchWrapupCodesValue={searchWrapupCodes}
          />
        </DxTabPanel>
      </DxTabbedContent>
    </>
  );
}
